import React from 'react';
import { Menu, Button, Image } from 'antd';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { useLocation, useNavigate } from 'react-router-dom';
import Profile from './Profile';
import { LayoutDashboard, Presentation, Users } from 'lucide-react';
import { useAppStore } from '../store/appStore';

interface SidebarProps {
  collapsed: boolean;
  onCollapseToggle: () => void;
  isMobile: boolean;
  setDrawerOpen?: (open: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  collapsed,
  onCollapseToggle,
  isMobile,
  setDrawerOpen,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const profile = useAppStore((state) => state.profile);

  const menuItems = [
    {
      key: '/dashboard',
      label: 'Dashboard',
      icon: <LayoutDashboard className="w-5 h-5" />,
    },
    ...(profile?.user.role.roleName === 'Meeting Manager' ||
    profile?.user.role.roleName === 'Marketing Manager' ||
    profile?.user.role.roleName === 'Meeting Manager'
      ? [
          {
            key: '/visits',
            label: 'Visits',
            icon: <Presentation className="w-5 h-5" />,
          },
        ]
      : []),
    ...(profile?.user.role.roleName === 'Super Admin'
      ? [
          {
            key: '/users',
            label: 'Users',
            icon: <Users className="w-5 h-5" />,
          },
        ]
      : []),
         ...(profile?.user.role.roleName === 'Super Admin'
      ? [
          {
            key: '/delete-user',
            label: 'Delete User',
            icon: <Users className="w-5 h-5" />,
          },
        ]
      : []),
    // {
    //   key: '/zones',
    //   label: 'Zones',
    //   icon: <Anchor className="w-5 h-5" />,
    // },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
    if (isMobile && setDrawerOpen) setDrawerOpen(false);
  };

  return (
    <div className="h-full flex flex-col">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '16px 24px',
          justifyContent: 'space-between',
        }}
      >
        <Image
          src="https://www.pgpfirst.com/wp-content/uploads/2023/08/logo.svg"
          preview={false}
          width={collapsed && !isMobile ? 25 : 40}
        />

        {!isMobile && (
          <Button
            type="text"
            onClick={onCollapseToggle}
            icon={
              collapsed ? (
                <ChevronRightIcon className="w-5 h-5 text-black" />
              ) : (
                <ChevronLeftIcon className="w-5 h-5 text-black" />
              )
            }
          />
        )}
      </div>
      <Menu
        theme="light"
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={handleMenuClick}
        items={menuItems}
        style={{ flex: 1 }}
      />
      <Profile collapsed={collapsed} />
    </div>
  );
};

export default Sidebar;
